import React, { useState } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import { IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { PlanData } from "types/models/planMaster/planMasterApp";
import DeleteMessage from "pages/apps/masters/manger_banner/banners/BannerTable/DeleteMessage";
import {
  deletePlan,
  getPlangetPlansByGroupCode,
} from "redux/actions/planMaster";
import { useDispatch } from "react-redux";
import { isModuleAuthorized } from "@crema/utility/Utils";

const StyledTableCell = styled(TableCell)(() => ({
  fontSize: 14,
  padding: 8,
  minWidth: 170,
  "&:first-of-type": {
    paddingLeft: 20,
  },
  "&:last-of-type": {
    paddingRight: 20,
  },
}));

interface TableItemProps {
  data: PlanData;
  onEditClick: (planGroupCode: string) => void;
}

const TableItem: React.FC<TableItemProps> = ({ data, onEditClick }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const dispatch = useDispatch();

  const handleEdit = () => {
    onEditClick(data.planGroupCode);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleConfirmDelete = () => {
    dispatch(deletePlan(data) as any)
      .then(() => {
        dispatch(getPlangetPlansByGroupCode() as any);
      })
      .catch((error) => {
        console.error("Error deleting user:", error);
      })
      .finally(() => {
        setOpenDialog(false);
      });
  };

  return (
    <>
      <TableRow key={data.planId} className="item-hover">
        <StyledTableCell>{data.planGroupCode}</StyledTableCell>
        <StyledTableCell>{data.groupCount}</StyledTableCell>
        <StyledTableCell align="right">
          {isModuleAuthorized("Edit Plan-Page Mapping") ? (
            <IconButton onClick={handleEdit} aria-label="edit">
              <EditIcon style={{ fontSize: 24 }} />
            </IconButton>
          ) : (
            <Tooltip title="You don't have permission to edit">
              <span>
                <IconButton disabled>
                  <EditIcon style={{ fontSize: 24, opacity: 0.5 }} />
                </IconButton>
              </span>
            </Tooltip>
          )}
        </StyledTableCell>
      </TableRow>

      <DeleteMessage
        open={openDialog}
        onClose={handleCloseDialog}
        onConfirmDelete={handleConfirmDelete}
      />
    </>
  );
};

export default TableItem;
